import React, { useState, useEffect } from 'react';
import LeadAssignmentService from '../services/leadAssignmentService';

const SalesTeamTest = () => {
  const [salesTeam, setSalesTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadSalesTeam();
  }, []);

  const loadSalesTeam = async () => {
    setLoading(true);
    setError('');
    
    try {
      console.log('Fetching sales team...');
      const result = await LeadAssignmentService.getSalesTeam();
      console.log('Sales team result:', result);
      
      if (result.success) {
        setSalesTeam(result.data);
        console.log('Sales team loaded:', result.data);
      } else {
        setError(result.message);
        console.error('Failed to load sales team:', result.message);
      }
    } catch (error) {
      console.error('Error loading sales team:', error);
      setError('Failed to load sales team');
    } finally {
      setLoading(false);
    }
  };

  const testDirectAPI = async () => {
    try {
      console.log('Testing direct API call...');
      const response = await fetch('https://leadmgnt.onrender.com/api/lead-assignment/sales-team');
      const data = await response.json();
      console.log('Direct API response:', data);
      alert(`Direct API Response: ${JSON.stringify(data, null, 2)}`);
    } catch (error) {
      console.error('Direct API error:', error);
      alert(`Direct API Error: ${error.message}`);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Sales Team Test</h1>
          <div className="space-x-4">
            <button
              onClick={loadSalesTeam}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Reload Sales Team
            </button>
            <button
              onClick={testDirectAPI}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
            >
              Test Direct API
            </button>
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-gray-600">Loading sales team...</span>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <h3 className="text-red-800 font-medium">Error</h3>
            <p className="text-red-600">{error}</p>
          </div>
        )}

        {/* Sales Team Display */}
        {!loading && !error && (
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-4">
              Sales Team Members ({salesTeam.length})
            </h2>
            
            {salesTeam.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                No sales team members found
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {salesTeam.map((member, index) => (
                  <div
                    key={member._id || index}
                    className="bg-gray-50 border border-gray-200 rounded-lg p-4"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="flex-shrink-0">
                        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
                          <span className="text-white font-medium">
                            {member.name?.charAt(0) || 'U'}
                          </span>
                        </div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {member.name}
                        </p>
                        <p className="text-sm text-gray-500 truncate">
                          {member.email}
                        </p>
                      </div>
                    </div>
                    
                    <div className="mt-3 space-y-1">
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-500">Role:</span>
                        <span className="font-medium text-gray-900">
                          {member.role}
                        </span>
                      </div>
                      
                      {member.department && (
                        <div className="flex justify-between text-xs">
                          <span className="text-gray-500">Department:</span>
                          <span className="font-medium text-gray-900">
                            {member.department.name}
                          </span>
                        </div>
                      )}
                      
                      {member.phone && (
                        <div className="flex justify-between text-xs">
                          <span className="text-gray-500">Phone:</span>
                          <span className="font-medium text-gray-900">
                            {member.phone}
                          </span>
                        </div>
                      )}
                      
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-500">Status:</span>
                        <span className={`font-medium ${
                          member.isActive ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {member.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* API Configuration Info */}
        <div className="mt-8 bg-gray-50 border border-gray-200 rounded-lg p-4">
          <h3 className="text-sm font-medium text-gray-900 mb-2">API Configuration</h3>
          <div className="text-xs text-gray-600 space-y-1">
            <div>Backend URL: https://leadmgnt.onrender.com</div>
            <div>Endpoint: /api/lead-assignment/sales-team</div>
            <div>Method: GET</div>
            <div>Expected: Only Sales Department employees</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesTeamTest;
